/**
 * @owner @Appboy/billing
 */

// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isCampaignCanvasConsumptionResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      name: string,
      campaign_id: anyOf(string, nullValidation),
      campaign_name: anyOf(string, nullValidation),
      canvas_id: anyOf(string, nullValidation),
      canvas_name: anyOf(string, nullValidation),
      app_group_id: string,
      email_sent: number,
      line_sent: number,
      content_card_impressions: number,
      banner_impressions: number,
      webhook_sent: number,
      sms_sent: number,
      rcs_sent: number,
      total_billable_count: number,
      sms_total: number,
    })
  ),
});
